<template>
     <VueRecaptcha :sitekey="this.sitekey" :loadRecaptchaScript="true" @verify="validate"/>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha'
export default {
  props: ['onSuccess'],
  data: () => ({
    sitekey: '6LdKilUiAAAAAJQFjLkEKpukIieJRZeygBoDerks', // sigs4: 6LdKilUiAAAAAJQFjLkEKpukIieJRZeygBoDerks
    vueWidgtId: 0
  }),
  components: {
    VueRecaptcha
  },
  mounted () {},
  methods: {
    validate (response) {
      this.onSuccess(response)
    }
  }
}
</script>

<style>

</style>
